import { env } from './env';
import { API_CONSTANTS } from './api-constants';

export const API_CONFIG = {
  BASE_URL: env.API_BASE_URL,
  UPI_SWITCH_BASE_URL: API_CONSTANTS.UPI_SWITCH_BASE_URL,
  IMPS_BASE_URL: API_CONSTANTS.IMPS_BASE_URL,
  BBPS_BILLS_BASE_URL: API_CONSTANTS.BBPS_BILLS_BASE_URL,
} as const;
